'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.intlReducer = intlReducer;

var _constants = require('./constants');

var initialState = exports.initialState = function initialState() {
  return {
    cacheDisable: false,
    ecmaSupport: false,
    locale: '',
    messages: {}
  };
};

function intlReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  if (action && action.type === _constants.UPDATE_ACTION) {
    return _extends({}, state, action.payload);
  }

  return state;
}

exports.default = intlReducer;


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/intlReducer.js
// module id = 123
// module chunks = 0